import { Component, inject, OnInit } from '@angular/core';
import { PortalService } from 'app/core/core.module';
import { Guid } from 'app/core/data/entities';
import { Utility } from 'app/core/utility';
import { alert } from 'devextreme/ui/dialog';
import validationEngine from 'devextreme/ui/validation_engine';
import { Subject } from 'rxjs';

export class AchEmailModel {
    confirmationCode: Guid;
    to: string;
    cc: string;
    subject: string;
    body: string;
}

@Component({
    selector: 'app-ach-email-dialog',
    templateUrl: './ach-email-dialog.component.html',
    styleUrls: ['./ach-email-dialog.component.scss'],
    standalone: false
})
export class AchEmailDialogComponent implements OnInit {
    portalService = inject(PortalService);

    result = new Subject<{ success: boolean, value?: AchEmailModel }>();
    dealerId: number;
    confirmationCode: Guid;
    model: AchEmailModel;
    processing: boolean;

    async ngOnInit() {
        await this.getData();
    }

    async getData() {
        this.model = await this.portalService.getAchEmail(this.dealerId);
        this.model.confirmationCode = this.confirmationCode;
    }

    async send() {
        if (this.processing) return;
        this.processing = true;

        const isValid = this.valid();
        if (!isValid) {
            this.processing = false;
            return;
        }

        // const success = await this.portalService.sendAchEmail(this.model);
        // if (!success) {
        //     await alert(
        //         'Unable to send ACH Authorization Form. Please verify that the email addresses are correct or reach out to your sales representative for assistance.',
        //         'Unable To Send Form'
        //     );
        //     this.processing = false;
        //     return;
        // } else {
        //     await alert(`An ACH Authorization Form has been sent to ${this.model.to}`, 'Email Sent');
        // }
        this.result.next({ success: true, value: this.model });
    }

    cancel() {
        this.result.next({ success: false });
    }

    valid() {
        const groupConfig = validationEngine.getGroupConfig('achEmailValidationGroup');
        if (groupConfig) {
            const result = validationEngine.validateGroup('achEmailValidationGroup');
            return result.isValid;
        }
        return true;
    }

    validateEmail = (e: any) => {
        const emails = e.value;
        return !emails || Utility.validateEmailAddresses(emails);
    };
}
